import { render, staticRenderFns } from "./storeClientList.vue?vue&type=template&id=c05d51e8&scoped=true&"
import script from "./storeClientList.vue?vue&type=script&lang=js&"
export * from "./storeClientList.vue?vue&type=script&lang=js&"
import style0 from "./storeClientList.vue?vue&type=style&index=0&id=c05d51e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05d51e8",
  null
  
)

export default component.exports